import { Text } from 'designSystem/components/Text'
import { usePipelineConfig } from 'features/knowledgeDocumentViewer/contexts/PipelineConfigContext'
import { PermissionsGate } from 'features/permissions'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import { DocumentTabs } from './DocumentTabs'
import {
  PreviewModeSwitchButton,
  PreviewModeSwitchThumb,
  PreviewModeSwitchTrack,
  TabsWrapper,
  Toolbar,
  ToolbarAgentButtonSlot,
} from './documentTabsStyles'

export function DocumentTabsBar() {
  const { isPreviewMode, setIsPreviewMode, hasPreviewConfig } =
    usePipelineConfig()

  const handlePreviewModeToggle = (): void => {
    setIsPreviewMode((currentValue) => !currentValue)
  }

  return (
    <Toolbar>
      <TabsWrapper>
        <DocumentTabs />
      </TabsWrapper>
      <ToolbarAgentButtonSlot>
        <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
          {hasPreviewConfig && (
            <PreviewModeSwitchButton
              type='button'
              role='switch'
              aria-checked={isPreviewMode}
              aria-label={`Preview mode ${isPreviewMode ? 'on' : 'off'}`}
              title='Toggle Preview Mode'
              $checked={isPreviewMode}
              onClick={handlePreviewModeToggle}>
              <PreviewModeSwitchTrack $checked={isPreviewMode}>
                <PreviewModeSwitchThumb $checked={isPreviewMode} />
              </PreviewModeSwitchTrack>
              <span>Preview</span>
              <Text color='muted'>{isPreviewMode ? 'On' : 'Off'}</Text>
            </PreviewModeSwitchButton>
          )}
        </PermissionsGate>
      </ToolbarAgentButtonSlot>
    </Toolbar>
  )
}
